
"use strict";

class POIVisibilityTag {

	constructor(tagName, visible) {

		this.tagName = tagName;
		this.visible = visible;		
	}
}

class POIVisibilityState {

	constructor() {

		this.tags = [];		
	}

	setTagState(tagName, visible) {

		let isPresent = false;
		for(let i=0; i<this.tags.length; i++) {
			if(this.tags[i].tagName.toLowerCase() === tagName.toLowerCase()) {
				this.tags[i].visible = visible;
				isPresent = true;
				break;
			}
		}
		if(!isPresent) {
			this.tags.push(new POIVisibilityTag(tagName.toLowerCase(), visible));
		}
	}

	getAllTags() {

		return this.tags;
	}

	getDisabledTags() {

		let disabledTags = [];
		for(let i=0; i<this.tags.length; i++) {
			if(!this.tags[i].visible) {
				disabledTags.push(this.tags[i].tagName);
			}
		}
		return disabledTags;
	}

	isVisible(tagName) {

		for(let i=0; i<this.tags.length; i++) {
			if(this.tags[i].tagName.toLowerCase() === tagName.toLowerCase()) {
				return this.tags[i].visible;
			}
		}

		return null;
	}
}
